module.exports = __webpack_public_path__ + "static/media/avatar.fe582b1c.png";